// Smart Sash Admin Panel - Missing Parameters Error Component
// Error state for missing registration URL parameters

import React from 'react';

interface MissingParametersErrorProps {
  errorMessage?: string;
}

/**
 * Missing Parameters Error Component
 * Displayed when sessionId or institutionId parameters are missing from the URL
 */
export const MissingParametersError: React.FC<MissingParametersErrorProps> = ({ errorMessage }) => {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5 text-center">
                <div className="mb-4">
                  <i
                    className="fas fa-exclamation-circle text-danger"
                    style={{ fontSize: '4rem' }}
                  ></i>
                </div>

                <h1 className="h3 mb-3 fw-bold">Invalid Link</h1>

                <p className="text-muted mb-4">
                  {errorMessage || 'The registration link is invalid or incomplete.'}
                </p>

                <div className="alert alert-info" role="alert">
                  <i className="fas fa-info-circle me-2"></i>
                  Please scan your RFID tag at the registration device to receive your registration
                  link.
                </div>

                <div className="text-center mt-4 pt-4 border-top">
                  <p className="text-muted small mb-0">
                    &copy; {new Date().getFullYear()} H. H. Hawkins Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissingParametersError;
